import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import ArticlesSection from './components/ArticlesSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '久久在线 – 随时随地畅享在线服务',
    description: '久久在线为您提供稳定、高速、全天候的在线服务体验。无论何时何地，久久在线都能满足您的需求，让您享受流畅、安全、便捷的数字生活。',
    url: 'https://www.jiujiuzaixian.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '久久在线',
      url: 'https://www.jiujiuzaixian.com',
    },
    about: {
      '@type': 'Organization',
      name: '久久在线',
      url: 'https://www.jiujiuzaixian.com',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '久久在线是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '久久在线提供免费基础版供个人用户体验，包含视频服务、云存储基础功能和在线办公基础功能。如需更多高级功能和更大存储空间，可选择我们的专业版或企业版套餐。',
        },
      },
      {
        '@type': 'Question',
        name: '久久在线支持哪些设备？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '久久在线支持全平台使用，包括Windows、macOS、iOS、Android等主流操作系统，同时提供Web网页版，无需安装即可使用。所有设备间数据实时同步。',
        },
      },
      {
        '@type': 'Question',
        name: '久久在线的视频播放画质如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '久久在线视频服务支持最高4K超高清画质播放，采用自适应码率技术，根据您的网络状况自动调整最佳画质，确保流畅不卡顿的观看体验。',
        },
      },
      {
        '@type': 'Question',
        name: '如何保障我的数据安全？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '久久在线采用银行级AES-256加密技术，数据传输全程使用TLS 1.3加密协议。同时通过ISO 27001安全认证和等保三级认证，建立了完善的数据安全管理体系。',
        },
      },
      {
        '@type': 'Question',
        name: '久久在线支持企业定制吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '支持！久久在线企业版提供专属管理后台、API接口、SSO单点登录等功能，可以根据企业需求进行深度定制。欢迎联系我们的企业服务团队获取专属方案。',
        },
      },
      {
        '@type': 'Question',
        name: '遇到问题如何联系客服？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过在线客服、官方邮箱contact@jiujiuzaixian.com、客服热线400-888-9999等多种渠道联系我们。我们的客服团队7×24小时为您提供专业支持。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <SEO
        title="久久在线 – 随时随地畅享在线服务 | 久久在线官网"
        description="久久在线为您提供稳定、高速、全天候的在线服务体验。无论何时何地，久久在线都能满足您的需求，让您享受流畅、安全、便捷的数字生活，立即体验久久在线带来的极致服务。"
        keywords="久久在线,久久在线官网,久久在线免费,久久在线高清,久久在线视频,久久在线观看,久久在线入口"
        canonicalUrl="https://www.jiujiuzaixian.com/"
      />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>

      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <ArticlesSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}